<!-- <ng-container *ngIf="actors && actors.length > 0"> -->

  <!-- Large viewport -->
  <div class="d-none d-lg-block">
    <h2 class="element-title text-truncate" translate="Request.Status.Actions"></h2>
    <desktop-status-actions-table [tableData]="actors"
      [displayedColumns]="columnsToDisplay"></desktop-status-actions-table>
  </div>
<!-- </ng-container> -->